import { Avatar, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import stringToColor from 'string-to-color'

const useStyles = makeStyles({
    avatar: (props) => ({
        backgroundColor: stringToColor(props.category.name.substr(0, 3)),
    }),
})

export default function CategoryListItem(props) {
    const { category, numItems, searching } = props
    const classes = useStyles(props)

    function handleViewClick() {
        props.onViewClick(category.id)
    }

    return (
        <ListItem key={category.id} button onClick={handleViewClick}>
            <ListItemAvatar>
                <Avatar alt={category.name} classes={{ root: classes.avatar }}>
                    {category.name[0]}
                </Avatar>
            </ListItemAvatar>
            <ListItemText
                primary={category.name}
                secondary={searching ? `${numItems} matching products` : `${numItems} products`}
            />
        </ListItem>
    )
}
